export default __webpack_public_path__ + "static/media/Bank Project.f2b782af.png";